import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from 'rxjs';
import { Ng2IzitoastService } from "ng2-izitoast";
import { DataTableDirective } from 'angular-datatables';
import { UsuariosService } from 'src/app/services/usuarios.service';


@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit, OnDestroy {

  respuestaGet: any;
  respuestaAgregar: any;
  respuestaEditar: any;
  respuestaUpdate: any;
  respuestaDesactivar: any;
  respuestaGetInactivos: any;

  formulario;
  formularioEdit;
  usuarioid;
  datosUsuario;
  activar = 1;
  guardandoUsuario = false;
  private dataTableInicializada = false;
  private componenteDestruido = false;

  dataTable: any;
 

  usuarios = [];
  data;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(private modalService: NgbModal, private _getUsuarios: UsuariosService, 
    private _agregarUsuario: UsuariosService, private _editarUsuario: UsuariosService,
    private _desactivarUsuario: UsuariosService, private _activarUsuario: UsuariosService,
    private _updateUsuario : UsuariosService, private _getUsuariosInactivos: UsuariosService,
    public iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 20,
      processing: true
    };

    this.formulario = {
      nombre: '',
      apellidos: '',
      celular: '',
      email: '',
      password: '',
      tipo:'',
    }

    this.formularioEdit = {
      nombre: '',
      apellidos: '',
      celular: '',
      email: '',
      password: '',
      tipo:'',
    }

    this.usuarios = [];
    this.getUsuarios();

  }

  getUsuarios(){
    this._getUsuarios.getUsuarios().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.usuarios = this.respuestaGet.content;
          this.refrescarTabla();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getUsuariosActivos(){
    $('#inactivos').removeClass('fondoAmarillo');
    $('#inactivos').removeClass('blanco');

    $('#activos').addClass('fondoAmarillo');
    $('#activos').addClass('blanco');

    this._getUsuarios.getUsuarios().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.usuarios = this.respuestaGet.content;
          this.activar = 1;
          this.refrescarTabla();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getUsuariosInactivos(){
    $('#activos').removeClass('fondoAmarillo');
    $('#activos').removeClass('blanco');

    $('#inactivos').addClass('fondoAmarillo');
    $('#inactivos').addClass('blanco');

    this._getUsuariosInactivos.getUsuariosInactivos().subscribe(
      data => {
        this.respuestaGetInactivos = data;
        if(this.respuestaGetInactivos.success){
          this.usuarios = this.respuestaGetInactivos.content;
          this.activar = 2
          this.refrescarTabla();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarUsuario(){
    if (!this.validarFormularioUsuario()) {
      return;
    }

    this.guardandoUsuario = true;
    this.data = {
      'first_name': this.formulario.nombre,
      'last_name': this.formulario.apellidos,
      'celular': this.formulario.celular,
      'email': this.formulario.email,
      'username': this.formulario.celular,
      'password': this.formulario.password,
      'tipo': this.formulario.tipo,
    }

    this._agregarUsuario.agregarUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el usuario correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.limpiarFormularioUsuario();
          this.dismissAll();
          this.getUsuarios();
        }else {
          this.iziToast.show(
            {
                title: this.obtenerMensajeError(this.respuestaAgregar.error),
                titleColor: '#ffffff',
                color: '#CA0B00',
                position: 'topRight',
                closeOnEscape: true,
            });
          // alert('No se cargaron los datos');
        }
        this.guardandoUsuario = false;
      }, error => {
        this.guardandoUsuario = false;
        console.error(error);
      });
  }

  editarUsuario(usuario){
    this.data = {
      'usuario':usuario,
    }
    this._editarUsuario.editarUsuario(this.data).subscribe(
      data => {
        this.respuestaEditar = data;
        if(this.respuestaEditar.success){
          this.datosUsuario = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosUsuario.nombre;
          this.formularioEdit.apellidos = this.datosUsuario.apellidos;
          this.formularioEdit.celular = this.datosUsuario.celular;
          this.formularioEdit.email = this.datosUsuario.email;
          this.formularioEdit.tipo = this.datosUsuario.tipo;
          this.formularioEdit.password = '';
          this.usuarioid = usuario;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  updateCliente(usuario){
    this.data = {
      'usuario': usuario, 
      'first_name': this.formularioEdit.nombre,
      'last_name': this.formularioEdit.apellidos,
      'celular': this.formularioEdit.celular,
      'email': this.formularioEdit.email,
      'password': this.formularioEdit.password,
      'tipo': this.formularioEdit.tipo,
    }

    this._updateUsuario.updateUsuario(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el usuario correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
            this.dismissAll();
            this.getUsuarios();
        }else {
          this.iziToast.show(
            {
                title: this.obtenerMensajeError(this.respuestaUpdate.error),
                titleColor: '#ffffff',
                color: '#CA0B00',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error));
  }

  desactivarUsuario(usuario){
    this.data = {
      'usuario': usuario, 
    }

    this._desactivarUsuario.desactivarUsuario(this.data).subscribe(
      data => {
        this.respuestaDesactivar = data;
        if(this.respuestaDesactivar.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el usuario correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getUsuarios();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  activarUsuario(usuario){
    this.data = {
      'usuario': usuario, 
    }

    this._activarUsuario.activarUsuario(this.data).subscribe(
      data => {
        this.respuestaDesactivar = data;
        if(this.respuestaDesactivar.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el usuario correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getUsuariosInactivos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

  ngOnDestroy(): void {
    this.componenteDestruido = true;
    this.dtTrigger.unsubscribe();
  }

  private refrescarTabla(): void {
    if (!this.dataTableInicializada) {
      this.dataTableInicializada = true;
      this.lanzarDataTable();
      return;
    }

    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.lanzarDataTable();
      });
    } else {
      this.lanzarDataTable();
    }
  }

  private lanzarDataTable(): void {
    setTimeout(() => {
      if (!this.componenteDestruido) {
        this.dtTrigger.next();
      }
    });
  }

  private validarFormularioUsuario(): boolean {
    if (!this.formulario.nombre || !this.formulario.apellidos || !this.formulario.celular ||
        !this.formulario.email || !this.formulario.password || !this.formulario.tipo) {
      this.iziToast.show(
        {
            title: 'Completa todos los campos del usuario.',
            titleColor: '#ffffff',
            color: '#CA0B00',
            position: 'topRight',
            closeOnEscape: true,
        });
      return false;
    }

    return true;
  }

  private limpiarFormularioUsuario(): void {
    this.formulario = {
      nombre: '',
      apellidos: '',
      celular: '',
      email: '',
      password: '',
      tipo:'',
    }
  }

  private obtenerMensajeError(error): string {
    if (!error) {
      return 'No se pudo guardar el usuario.';
    }

    if (typeof error === 'string') {
      return error;
    }

    return JSON.stringify(error);
  }

}
